import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import { i18n } from './plugins/i18n';
import apiConfiguration from '@/../_config/_app/apiConfiguration.json';
import appSettings from '@/plugins/appSettings';
import idleTimeout from '@/plugins/idleTimeout';
import VuePdfApp from 'vue-pdf-app';
import VueGtag from 'vue-gtag';
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false;
Vue.prototype.$apiConfiguration = apiConfiguration;
Vue.prototype.$appSettings = appSettings;
Vue.prototype.$idleTimeouts = idleTimeout;
Vue.component('vue-pdf-app', VuePdfApp);
Vue.use(VueGtag, {
  config: { id: appSettings.dcoConfigurations.googleAnalyticsConfigId },
});

new Vue({
  vuetify,
  router,
  store,
  i18n,
  idleTimeout,
  apiConfiguration,
  appSettings,
  render: (h) => h(App),
}).$mount('#app');
